module.exports = __webpack_public_path__ + "img/29.538fdbdd.jpg";